const CLIENTS = {
  SET_CLIENTS_QUERY: 'SET_CLIENTS_QUERY',

};

export default CLIENTS;
